import { useEffect } from 'react';

import tracking from 'dibs-tracking';
import { getAbTestTrackingData } from 'dibs-buyer-layout/exports/clientABTestHelpers';

const MAKE_OFFER_TEST_NAME = 'MAKE_OFFER_CONTACT';
const PAGE = 'PDP';

export function useMakeOfferTestTrackingEffect({ isEligible }) {
    useEffect(
        function handleAbTestTracking() {
            if (isEligible) {
                const trackingData = getAbTestTrackingData(document.cookie, MAKE_OFFER_TEST_NAME);
                tracking.trackAbTestEvent(trackingData, PAGE);
            }
        },
        [isEligible]
    );
}
